import React, { useState } from 'react';
import { Card, CardContent } from '@mui/material';
import { getPriceDifferenceColor } from './orderUtils';
import { Trash2 } from 'lucide-react';
import ConfirmationDialog from '../ConfirmationDialog';
import { useSelector, useDispatch } from 'react-redux';
import { deleteLimitOrderRequest } from '../../store/reducers/orderReducer';
import { toIndianRupeeFormat } from '../custom.js';

const OrderCard = ({ order, allMarketData, onClick, activeTab }) => {
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null);
    const dispatch = useDispatch();

    const handleDeleteClick = (e, item) => {
        e.stopPropagation();
        setItemToDelete(item);
        setShowDeleteConfirm(true);
    };
    const handleDeleteConfirm = () => {

        if (itemToDelete) {
            dispatch(deleteLimitOrderRequest({ itemToDelete }));
        }
        setShowDeleteConfirm(false);
        setItemToDelete(null);
    };

    const handleDeleteCancel = () => {
        setShowDeleteConfirm(false);
        setItemToDelete(null);
    };
    return (
        <>
            <Card
                key={order.order_id || order.limit_order_id}
                className="px-0 py-1 mt-[-5px] h-[118px] bg-white"
                onClick={() => onClick(order)}
                style={{ cursor: "pointer" }}
                onClick={order.square_off === "1" && order.order_type === "market" ? undefined : () => onClick(order)}
                style={{
                    cursor:
                        order.square_off === "1" && order.order_type === "market"
                            ? "not-allowed"
                            : "pointer",

                    opacity:
                        order.square_off === "1" && order.order_type === "market"
                            ? 0.6
                            : 1,
                }}
            >
                <CardContent className="h-[118px] p-2">
                    <div className="flex justify-between items-center w-full">
                        <div className="flex flex-col items-start w-3/4 -mt-[10px] gap-y-2">
                            <div className="flex items-center">
                                <span className="font-semibold text-[16px]">{order.symbol}</span>
                                {/* <span className="font-semibold text-[11px] ml-2">{order.exchange}</span> */}
                            </div>
                            <span className="font-semibold text-[12px]">
                                <span
                                    className={`px-2 py-1 rounded-md text-white text-[10px] ${order.type === "buy" ? "bg-[#0076CE]" : "bg-red-500"
                                        }`}
                                >
                                    {order?.type?.toUpperCase()}
                                </span>
                                <span className="ml-2 text-gray-500">INTRADAY</span>
                            </span>
                            <span className="font-semibold text-[12px]">
                                <span className="text-gray-500 mr-2">{order?.order_type?.toUpperCase()}</span>
                                <span className="text-gray-500 mr-2">{order.qty}</span>
                            </span>
                            <span className="font-semibold text-[12px]">
                                <span className="text-black text-xs">date : </span>
                                <span className="ml-2 text-gray-500">{order.created_at}</span>
                            </span>
                        </div>

                        <div className="flex flex-col orders-end w-[46%] ml-[6px] -mt-[10px] gap-y-2 relative">
                            <span className="font-bold text-[12px]">
                                <span className="text-[12px] mr-1">
                                    {order.exchange}
                                </span>
                                {activeTab === "limit" && (
                                    <button
                                        onClick={(e) => handleDeleteClick(e, order)}
                                        className="p-1 text-red-400 hover:text-red-600 hover:bg-red-50 rounded-md transition-all duration-200 mr-2 absolute top-[-17px] right-[8px]"
                                        title="Delete from Limit"
                                    >
                                        <Trash2 className="w-5 h-5" />
                                    </button>
                                )}

                            </span>
                            <span className="font-semibold text-[12px]">
                                <span className="text-black text-xs">Price : </span>
                                <span className="ml-2 text-gray-500">{toIndianRupeeFormat(order.price)}</span>
                            </span>
                            <span className="font-semibold text-[12px] flex">
                                <span className="text-black text-xs w-10">CMD : </span>

                                {order.order_type === "market" && order.square_off === "1" ? (
                                    <span className="text-gray-400 text-[10px]">-</span>
                                ) : (
                                    allMarketData &&
                                    allMarketData
                                        .filter((orderDiff) => {
                                            const orderIdToCompare = order.order_id
                                                ? order.order_id
                                                : order.limit_order_id;

                                            const orderDiffIdToCompare = orderDiff.order_id
                                                ? orderDiff.order_id
                                                : orderDiff.limit_order_id;

                                            return (
                                                orderDiffIdToCompare === orderIdToCompare && orderDiff.priceDifference != null
                                            );
                                        })
                                        .map((orderDiff, idx) => {
                                            const key = `${orderDiff.order_id || orderDiff.limit_order_id}-${idx}`;

                                            const priceDifferenceColor = getPriceDifferenceColor(orderDiff.priceDifference);

                                            const sidePrice =
                                                order.order_type === "stoploss"
                                                    ? orderDiff.marketData.ltp
                                                    : orderDiff.type === "sell"
                                                        ? orderDiff.marketData.depth.sell[0].price
                                                        : orderDiff.marketData.depth.buy[0].price;
                                            return (
                                                <span
                                                    key={key}
                                                    className={`font-semibold w-28 text-[11px] ${priceDifferenceColor}`}
                                                >
                                                    {toIndianRupeeFormat(sidePrice.toFixed(2))}
                                                    {` (${orderDiff.priceDifference !== 0
                                                        ? (toIndianRupeeFormat(orderDiff.priceDifference * order.qty))
                                                        : "No Difference"
                                                        })`}
                                                </span>
                                            );
                                        })
                                )}
                            </span>

                        </div>
                    </div>
                </CardContent>
            </Card>
            <ConfirmationDialog
                isOpen={showDeleteConfirm}
                onClose={handleDeleteCancel}
                onConfirm={handleDeleteConfirm}
                title="Delete from Limit Orders"
                message={`Are you sure you want to remove "${itemToDelete?.script_name || 'this item'}" from your Limit Order?`}
                confirmText="Delete"
                cancelText="Cancel"
                type="danger"
            />
        </>
    );
};

export default OrderCard;